export default "/static/assets/lead.c54d1423258782473ab17eb0e4f12214.svg";